import React from 'react';
import commonUtil from './../../../utils/commonUtil';

const channel = commonUtil.getChannel();
export default class Counter extends React.Component {

  constructor(props) {
    super(props);
    this.setQuantity = this.setQuantity.bind(this);
    this.decrement = this.decrement.bind(this);
    this.increment = this.increment.bind(this);
    this.setDefaultValue = this.setDefaultValue.bind(this);

    this.count = 0;
    this.counterDisabled = false;
    this.makeDisableCounter = false;
  }

  setDefaultValue(defaultValue) {
    this.count = parseInt(defaultValue, 10);
    document.querySelector('#quantity').value = this.count;
  }
  makeDisable=(pMakeDisable) => {
    this.makeDisableCounter = pMakeDisable;
  }

  setQuantity() {
    const string = document.getElementById('quantity').value;
    const numbers = /^[0-9]+$/;
    if (string.match(numbers)) {
      if (document.querySelector('#quantity').value < 0) document.querySelector('#quantity').value = 0;
      if (document.querySelector('#quantity').value > 10) document.querySelector('#quantity').value = 10;
    } else {
      document.querySelector('#quantity').value = 0;
    }
    this.count = (document.querySelector('#quantity').value);
    if (this.props.setQuant) {
      this.props.setQuant(this.count);
    }
  }
  increment(count, id) {
    if (this.makeDisableCounter) {
      return;
    }
    if (document.querySelector('#' + id).value < this.props.max_length) {
      if (this.count >= 1000 || this.props.disabled) {
        document.querySelector('#incBtn').setAttribute('disabled', 'disabled');
      } else {
        this.count = this.count + 1;
        document.querySelector('#' + id).value = this.count;
        if (this.props.incFunction) { this.props.incFunction(); }
      }
    }
  }

  decrement(count, id, extra) {
    if (this.makeDisableCounter) {
      return;
    }
    if (this.count <= 0 || this.props.disabled) {
      document.querySelector('#decBtn').setAttribute('disabled', 'disabled');
    } else {
      this.count = this.count - 1;
      document.querySelector('#' + id).value = this.count;
      if (this.props.decFunction) { this.props.decFunction(extra); }
    }
  }

  render() {
    const inputBoxId = this.props.inputBox_Id;
    const maxLength = this.props.max_length;
    const minLength = this.props.min_length;

    /* eslint-disable */  // TODO: Need to check on same error
    const padding = {};

    channel === 'wap' ? padding.paddingLeft = '15px': '';
   
    return (
      /* <div className={channel ==='web'? "col-md-5 col-sm-5" : "col-xs-6"}>*/
    
        <div className="input-group quantityGroupGift">
          <span className="input-group-addon minus" id="decBtn" onClick={() => this.decrement(this.count, inputBoxId)}>-</span>
          <input style={padding} readOnly className="form-control quantityGroup" id={inputBoxId} type="text" placeholder="0" max={maxLength} min={minLength}  />
          <span id="incBtn" className="input-group-addon plus" onClick={() => this.increment(this.count, inputBoxId)}>+</span>
        </div>
      
    );
    /* eslint-enable */
  }
}

